import * as types from 'legacy/src/constants/types';

const updateAssessmentDataCache = (state = {}, action) => {
  switch (action.type) {
    case types.UPDATE_ASSESSMENT_CACHE:
      return {
        ...state,
        [action.itemId]: {
          ...state[action.itemId],
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default updateAssessmentDataCache;
